export type CardSize = 'sm' | 'md' | 'lg'

export const sizeVariants: Record<CardSize, string> = {
  sm: 'p-2 rounded-2xl',
  md: 'p-4 rounded-3xl',
  lg: 'p-8 md:p-10 rounded-3xl',
}

export type CardProps = {
  className?: string
  titleClassName?: string
  bodyClassName?: string
  title?: string
  size?: CardSize
  stretch?: boolean
  hasShowMore?: boolean
  onShowMore?: () => void
}
